import { InvalidUrlError } from '../../errors/errors';
import { BaseGQLService } from '../../services/BaseGQLService';
import { InfinitePaginationResult } from '../../types/pagination';
import { ModelType } from '../../utils/GQLIdEncoder';
import { SlotMapper } from '../mappers/SlotMapper';
import { Slot } from '../models/Slot';

const get_slots_query = (cursor: string | null) => {
  return `
      query (
        $perPage: Int,
        $issueId: ID!,
        ${cursor ? '$cursor: String,' : ''}
      ) {
        vulnerability: node(id: $issueId) {
          ... on Vulnerability {
            slots(
              first: $perPage,
              ${cursor ? `after: $cursor,` : ''}
            ) {
              pageInfo {
                hasNextPage
                endCursor
              }
              totalCount
              edges {
                node {
                  id
                  name
                  instancesPassed
                  instancesFailed
                  latestReportId
                }
              }
            }
          }
        }
      }
      `;
};

export class SlotRepository extends BaseGQLService {
  private readonly mapper = new SlotMapper();

  /**
   * Fetch list through infinite pagination approach where we only fetch data after cursor.
   */
  async getList(issueId: number, cursor: string | null, perPage = 10): Promise<InfinitePaginationResult<Slot>> {
    return this.query(
      get_slots_query(cursor),
      {
        perPage,
        issueId: this.gqlIdEncoder.encode(ModelType.Vulnerability, issueId),
        cursor,
      },
      (data) => {
        if (!data.vulnerability) {
          throw new InvalidUrlError(`Invalid request: could not find ${ModelType.Vulnerability} ${issueId}`);
        }
        const slotsData = data.vulnerability.slots;
        const slots = data.vulnerability.slots.edges.map((p: any) => this.mapper.mapToDomain(p.node));
        return {
          data: slots,
          cursor: slotsData.pageInfo.endCursor,
          hasNextPage: slotsData.pageInfo.hasNextPage,
          totalItems: slotsData.totalCount,
        };
      }
    );
  }
}
